import { render, staticRenderFns } from "./ManageTemplateDialog.vue?vue&type=template&id=a84e9ae6&scoped=true&"
import script from "./ManageTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./ManageTemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./ManageTemplateDialog.vue?vue&type=style&index=0&id=a84e9ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84e9ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
